import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-stepper-header',
  templateUrl: './stepper-header.component.html',
  styleUrls: ['./stepper-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepperHeaderComponent {
  @Input({ required: true })
  steps: string[];

  @Input({ required: true })
  currentStep: number;

  @Input()
  areStepsClickable = true;

  @Output()
  readonly stepClicked = new EventEmitter<number>();

  onStepClick(stepIndex: number): void {
    if (!this.areStepsClickable) {
      return;
    }

    if (stepIndex !== this.currentStep) {
      this.stepClicked.emit(stepIndex);
    }
  }
}
